<template>
  <div class="panel panel-member-detail-info">
    <div class="panel-content">
      <div class="tables">
        <!-- 標準項目 -->
        <data-list-table
          v-bind:id="'member-data-list-table-standard'"
          v-bind:data="standardData"
        />
        <!-- ユーザー属性 -->
        <data-list-table
          v-bind:id="'member-data-list-table-attribute'"
          v-bind:data="attributeData"
          class="following-table"
        />
      </div>
      <hr class="separator" />
      <div class="history">
        <p class="item">
          <span class="label" v-t="'appPanelMemberDetailInfo.label.created'" />
          <span class="text">
            {{ historyMessage.created }}
          </span>
        </p>
        <p class="item">
          <span
            class="label"
            v-t="'appPanelMemberDetailInfo.label.lastUpdated'"
          />
          <span class="text">
            {{ historyMessage.updated }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { DataListTable } from 'ifield-core-components'
import { ATTRIBUTE_TYPE } from 'ifield-core-components'
import { DATE_FORMAT_SLASH, TIME_FORMAT_MINUTE } from '@/constants.js'

// 表示時刻フォーマット
const DATE_FORMAT = `${DATE_FORMAT_SLASH} ${TIME_FORMAT_MINUTE}`

export default {
  name: 'AppPanelMemberDetailInfo',
  components: {
    'data-list-table': DataListTable,
  },
  props: {
    /**
     * ユーザーデータ
     */
    data: {
      type: Object,
      default: null,
    },
  },
  computed: {
    /**
     * ユーザーID
     * @type {Number}
     */
    userId: function () {
      return (this.data && this.data.id) || null
    },
    /**
     * 詳細表示用データ(標準項目分)
     * @type {Object}
     */
    standardData: function () {
      if (!this.data) return []

      // 主所属が先頭になるようにソート
      const groups = [...(this.data?.groups || [])].sort(
        (a, b) => +b.default_organization - +a.default_organization
      )
      return [
        {
          label: this.$t('appPanelMemberDetailInfo.field.organization'),
          value: groups.map((g) => g.organization_name).join(', '),
        },
        [
          {
            label: this.$t('appPanelMemberDetailInfo.field.tel'),
            value: this.data.tel,
          },
          {
            label: this.$t('appPanelMemberDetailInfo.field.email'),
            value: this.data.email,
          },
        ],
        {
          label: this.$t('appPanelMemberDetailInfo.field.remarks'),
          value: this.data.remarks,
          type: ATTRIBUTE_TYPE.STRING,
        },
      ]
    },
    /**
     * 詳細表示用データ(ユーザー属性分)
     * @type {Array.<Object>}
     */
    attributeData: function () {
      if (!this.data || !this.data.attributes) return []
      return this.data.attributes.map((attr) => ({
        label: attr.attribute_name,
        type: attr.attribute_type,
        value: attr.attribute_value,
      }))
    },
    /**
     * 登録更新履歴メッセージ
     * @type {Object}
     */
    historyMessage: function () {
      const created = this.$t('appPanelMemberDetailInfo.message.created', {
        date: this.data ? moment(this.data.create_at).format(DATE_FORMAT) : '',
        user: this.data ? this.data.create_user_name : '',
      })
      const updated = this.$t('appPanelMemberDetailInfo.message.lastUpdated', {
        date: this.data ? moment(this.data.update_at).format(DATE_FORMAT) : '',
        user: this.data ? this.data.update_user_name : '',
      })
      return { created, updated }
    },
  },
}
</script>

<style lang="scss" scoped>
.panel {
  width: 100%;
  height: 100%;
  color: $text-color;
  background-color: $dialog-background-color;
}

.panel-content {
  height: 100%;
  padding: 22px 22px 0 22px;
  overflow-y: auto;
  @include mixin-scrollbar;
  & {
    border-right: 1px solid #f0f0f0;
  }
}

.following-table {
  margin-top: -1px;
}

.separator {
  border-top: 1px solid #cccccc;
}

.history {
  font-size: $font-size-small;
  margin-bottom: 1rem;

  .item {
    margin: 0;
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;

    .label {
      flex-shrink: 0;
      flex-wrap: nowrap;
    }
  }
}
</style>
